import { ref as a } from "vue";
function i(o) {
  var u, s, e;
  const t = (u = o.value) == null ? void 0 : u.getClientRects();
  return !!((s = o.value) != null && s.offsetWidth) || !!((e = o.value) != null && e.offsetHeight) || (t == null ? void 0 : t.length) === 1;
}
function f(o) {
  if (!i(o)) {
    console.log(
      "[useRModalDialogFocus._focusElement()]: Cant focus an element that is not visible. Element was:",
      o.value
    );
    return;
  }
  o.value && o.value.focus && i(o) && o.value.focus({
    preventScroll: !0
  });
}
function l(o) {
  return a(o);
}
function d() {
  function o(e) {
    const n = l(e);
    f(n);
  }
  function t(e) {
    f(e);
  }
  function u(e) {
    let n = e;
    if (!n) {
      const c = document.querySelector("body");
      if (!c) {
        console.error(
          "[useRModalDialogFocus.focusOpenCTARef()]: Cant focus no element was given and body tag does not exist"
        );
        return;
      }
      n = a(c);
    }
    f(n);
  }
  function s(e) {
    const n = l(e);
    u(n);
  }
  return {
    focusOpenCTAComponentInstance: s,
    focusElementInModal: o,
    focusModal: t,
    focusOpenCTARef: u
  };
}
export {
  d as useRDialogFocus
};
